import { Box } from '@hivebrite/design-system/Box';
import {
  CONTENT_TYPES,
  ContentList,
} from '@hivebrite/design-system/ContentList';

import { useLandingContext } from 'hb-react/frontoffice/apps/LiveFeed/contexts/LandingContext';

import Landing from '../Landing';

const displayFields = {
  [CONTENT_TYPES.FORUM]: {
    content: true,
  },
};

const ForumDiscussion = () => {
  const { id, coverPicture, title, content, owner } = useLandingContext();

  const path = Routes.forum_thread_path(id);

  const data = [
    {
      id,
      author: owner,
      imageSrc: coverPicture?.medium_url,
      name: title,
      content,
      path,
      contentType: CONTENT_TYPES.FORUM,
    },
  ];

  return (
    <Landing
      title={s__('LiveFeed|created a <strong>forum discussion</strong>')}
      displayContent={false}
    >
      <Box mt={4} display="block">
        <ContentList
          data={data}
          variant="bordered"
          displayFields={displayFields}
          isCardClickable
          max={1}
        />
      </Box>
    </Landing>
  );
};

export default ForumDiscussion;
